import ButtonComponent from '../../../../../atoms/button/index.jsx'
import {
  buttonTypeOptions,
  buttonVariantOptions
} from '../../../../../atoms/button/constants.js'
import {
  Notification,
  NotificationUnreadMessages
} from '../../../../../atoms/icons/menu/index.js'
import { IconContainer } from '../../../styled-components.js'
import colorsOptions from '../../../../../fundamentals/colors-styles/constants.js'

const NotificationIcon = ({ hasUnreadNotifications }) => {
  const icon = hasUnreadNotifications ? (
    <NotificationUnreadMessages
      fill={colorsOptions.greys.white}
      specialFill={colorsOptions.docuToolsOrange.orange}
      specialStroke={colorsOptions.docuToolsOrange.orange}
    />
  ) : (
    <Notification />
  )

  return (
    <IconContainer>
      <ButtonComponent
        variant={buttonVariantOptions['GHOST-INVERTED']}
        buttonType={buttonTypeOptions['ICON-ONLY']}
      >
        {icon}
      </ButtonComponent>
    </IconContainer>
  )
}

export default NotificationIcon
